export const fetchRenewalDetailFormOptions = `
  query renewalDetailFormOptions($categoryId: Int!) {
    renewalDetailFormOptions(categoryId: $categoryId) {
      criteriaDetailsQuestionsOptions
      pricesQuestionsOptions
    }
  }
`;
